var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/goBack.fed25c02.png","uri@2x": __webpack_public_path__ + "static/media/goBack.b206c607.png","uri@3x": __webpack_public_path__ + "static/media/goBack.3b7d9b9b.png",
    width: 40,
    height: 40
});